import { getAssetUrl } from "./assets"

// TJMA2001 走时表:按震源深度查 P/S 波在震后经过时间的传播距离,支持线性插值。

export function parseTravelTimeTable(text) {
  const lines = text.trim().split("\n")
  const data = {}

  for (const line of lines) {
    const parts = line.trim().split(/\s+/)
    if (parts.length !== 6) continue

    const pTime = parseFloat(parts[1])
    const sTime = parseFloat(parts[3])
    const depth = parseInt(parts[4])
    const distance = parseInt(parts[5])

    if (!data[depth]) data[depth] = []
    data[depth].push({
      distance: distance,
      pTime: pTime,
      sTime: sTime,
    })
  }

  // 按距离排序
  for (const depth in data) {
    data[depth].sort((a, b) => a.distance - b.distance)
  }

  return data
}

let travelTimeTable = null

export async function loadTravelTimeTable() {
  if (travelTimeTable) return travelTimeTable
  try {
    const response = await fetch(getAssetUrl("data/tjma2001.txt"))
    const text = await response.text()
    travelTimeTable = parseTravelTimeTable(text)
    return travelTimeTable
  } catch (error) {
    console.error("Failed to load TJMA2001 data:", error)
    return null
  }
}

// 在给定深度的走时表中,按经过时间插值出传播距离(km);时间超出表尾时取最大距离
export function travelTimeDistance(data, depth, elapsedTime, timeField) {
  if (!data) return 0

  // 找到最接近的深度数据
  const availableDepths = Object.keys(data)
    .map((d) => parseInt(d))
    .sort((a, b) => a - b)
  let targetDepth = availableDepths[0]

  for (const d of availableDepths) {
    if (Math.abs(d - depth) < Math.abs(targetDepth - depth)) {
      targetDepth = d
    }
  }

  const depthData = data[targetDepth]
  if (!depthData) return 0

  // 找到对应时间的距离
  for (let i = 0; i < depthData.length; i++) {
    const current = depthData[i]
    if (current[timeField] >= elapsedTime) {
      if (i === 0) return current.distance

      // 线性插值
      const prev = depthData[i - 1]
      const ratio = (elapsedTime - prev[timeField]) / (current[timeField] - prev[timeField])
      return prev.distance + ratio * (current.distance - prev.distance)
    }
  }

  return depthData[depthData.length - 1].distance
}

export function pWaveDistance(data, depth, elapsedTime) {
  return travelTimeDistance(data, depth, elapsedTime, "pTime")
}

export function sWaveDistance(data, depth, elapsedTime) {
  return travelTimeDistance(data, depth, elapsedTime, "sTime")
}
